module.exports = __webpack_public_path__ + "check.svg?1793698113381";